import PropTypes from "prop-types";

import { getResponsePercentage } from "@/view/PollContainer/helpers";
import {
  pollQuestionProptype,
  choiceProptype,
} from "@/view/PollContainer/PollProptypes";
import {
  responsePercentageCss,
  pollOptionWithResultsCss,
  pollOptionWithResultsTextCss,
} from "./PollOptionWithResults.style";
import ResultsLabel from "./ResultsLabel";

const propTypes = {
  choice: choiceProptype,
  pollData: pollQuestionProptype,
  userId: PropTypes.string,
};

const PollOptionWithResults = ({ choice, pollData, userId }) => {
  const { text, votes: voteCount } = choice;

  const responsePercentage = getResponsePercentage(pollData, voteCount);

  return (
    <>
      <div css={responsePercentageCss}>{responsePercentage}%</div>
      <div css={pollOptionWithResultsCss(responsePercentage)}>
        <span css={pollOptionWithResultsTextCss}>{text}</span>
        <ResultsLabel choice={choice} userId={userId} />
      </div>
    </>
  );
};

PollOptionWithResults.propTypes = propTypes;

export default PollOptionWithResults;
